//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeatureGuidePanel from '@/components/new/FeatureGuidePanel.vue'
import { resolveMediaUrl } from '@/utils/mediaUrl'
export default {
  components: { FeatureGuidePanel },
  data () {
    return {
      list: [], hot: [], status: 'ongoing',
      statuses: [{ k: 'ongoing', n: '进行中' }, { k: 'upcoming', n: '即将开始' }, { k: 'ended', n: '已结束' }, { k: 'all', n: '全部' }]
    }
  },
  computed: {
    backTarget () { return this.$route.query.from === 'mine' ? '/mine' : '/home' }
  },
  created () {
    this.$ajax.get(this.$api.slContestHot).then(r => { this.hot = r || [] }).catch(() => {})
    this.load('ongoing')
  },
  methods: {
    coverOf (c) {
      return resolveMediaUrl(c.coverImage || c.cover_image || '')
    },
    load (s) {
      this.status = s
      const q = s && s !== 'all' ? ('?status=' + s) : ''
      this.$ajax.get(this.$api.slContestList + q).then(r => { this.list = (r && r.list) || [] }).catch(() => { this.list = [] })
    },
    go (id) { this.$router.push({ path: '/slContest_display', query: { id } }) },
    statusText (s) {
      return ({ ongoing: '进行中', upcoming: '即将开始', ended: '已结束' })[s] || s
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/index.vue